import { useQuery } from 'react-query';

import { useAccountStore } from '../components/Stores/accountStore';
import { getAllInventoryReportOfAccount } from '../sp-firebase/inventoryReportFB';
import { IInventoryReportType } from '../sp-types/InventoryReportType';
import { StatusType } from '../sp-types/statusType';

export const useInventoryReports = (statusTypes: StatusType[] = ['completed']) => {
  const fetchInventoryByAccount = async (accountId: string): Promise<IInventoryReportType[] | null> => {
    if (!accountId) return null;
    try {
      const inventory = await getAllInventoryReportOfAccount(accountId, statusTypes);
      return inventory;
    } catch (error) {
      console.error('Error fetching inventory:', error);
    }
    return null;
  };

  const { account } = useAccountStore();

  const fetchFunction = () => fetchInventoryByAccount(account.id || '');

  return useQuery('InventoryReports', fetchFunction, { enabled: account.id !== undefined });
};
